import { render, staticRenderFns } from "./ExamLayout.vue?vue&type=template&id=a2915758&"
import script from "./ExamLayout.vue?vue&type=script&lang=js&"
export * from "./ExamLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2915758')) {
      api.createRecord('a2915758', component.options)
    } else {
      api.reload('a2915758', component.options)
    }
    module.hot.accept("./ExamLayout.vue?vue&type=template&id=a2915758&", function () {
      api.rerender('a2915758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamLayout.vue"
export default component.exports